import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialSearchResultState: Dtos.SearchResult & IRegistrationFormState = {
    searchFor: null,
    trials: [],
    projects: [],
    institutions: [],
    laboratories: [],
    personnel: [],
    committees: [],
    groups: [],
    hrecs: [],
    healthDistricts: [],
    saveAndReturn: false,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null
}

export interface ISearchResultReduxFormState {
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>,
    trials: IFieldState<Dtos.Trial[]>,
    projects: IFieldState<Dtos.Project[]>,
    institutions: IFieldState<Dtos.Institution[]>,
    laboratories: IFieldState<Dtos.Laboratory[]>,
    personnel: IFieldState<Dtos.Personnel[]>,
    committees: IFieldState<Dtos.Committee[]>,
    groups: IFieldState<Dtos.Group[]>,
    hrec: IFieldState<Dtos.Hrec[]>,
    healthDistricts: IFieldState<Dtos.HealthDistrict[]>,
}
